import * as React from "react";
import { connect } from "react-redux";
import { createRouteNodeSelector } from "redux-router5";

import { navigate } from "~/router";

import SideMenu from "~/common/menu/SideMenu";
import { Features, UserRole, Permissions } from "~/apps/shared/consts";

function SideMenuContainer(props) {
  const {
    route,
    features,
    auth: {
      currentUser: { role, permissions },
    },
  } = props;
  
  const isLocationSelect = role !== UserRole.WAREHOUSE_MANAGER;
  const isProductsEnabled =
    features?.includes(Features.ENABLE_PRODUCTS_PAGE) &&
    permissions?.includes(Permissions.MANAGE_PRODUCTS) &&
    (role === UserRole.AGENT || role === UserRole.WAREHOUSE_MANAGER);

  let items = [
    {
      iconClass: "i-dollar",
      text: "Sales",
      isActive: route.name.startsWith("pos.admin.sales"),
      onClick: (e) => navigate("pos.admin.sales"),
    },
  ];

  if (isLocationSelect) {
    items.push({
      iconClass: "i-buildings",
      text: "Locations",
      isActive: route.name.startsWith("pos.admin.locations"),
      onClick: (e) => navigate("pos.admin.locations"),
    });
  }

  if (isProductsEnabled) {
    items.push({
      iconClass: "i-dollar",
      text: "Products",
      isActive: route.name.startsWith("pos.admin.products"),
      onClick: (e) => navigate("pos.admin.products"),
    });
  }

  items.push({
    iconClass: "i-cog",
    text: "Settings",
    isActive: route.name.startsWith("pos.admin.settings"),
    onClick: (e) => navigate("pos.admin.settings"),
  });

  return <SideMenu items={items} />;
}

const mapStateToProps = (state) => {
  const routeNodeSelector = createRouteNodeSelector("pos.admin");

  return {
    auth: state.shared.auth,
   features: state.shared.information.entities.features,
    ...routeNodeSelector(state),
  };
};

export default connect(mapStateToProps)(SideMenuContainer);
